export const STORAGE_KEY = {
	ACCESS_TOKEN: 'ACCESS_TOKEN',
	REFRESH_TOKEN: 'REFRESH_TOKEN',
	USER: 'USER_DATA',
	DEVICE_ID: 'DEVICE_ID'
};
export const Authorization = 'Bearer ';
